var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4687 5.32354H6.00483C3.95808 5.32354 2.29883 3.76802 2.29883 1.84916V0H4.29395C6.34073 0 7.99995 1.55552 7.99995 3.47438L8.4687 5.32354Z",
    fill: "#A9DB1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.32354H9.99512C12.0419 5.32354 13.7011 3.76802 13.7011 1.84916V0H11.706C9.65922 0 8 1.55552 8 3.47438V5.32354Z",
    fill: "#6BC800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53133 7.49707V8.94425L5.87183 10.5L6.53473 11.1215L7.53133 10.1872V11.7554L5.87183 13.3112L6.53473 13.9326L7.53133 12.9983V15.0003H8.00008L8.28086 7.49707H7.53133Z",
    fill: "#FFE3C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 10.1872L9.46534 11.1215L10.1283 10.5L8.46875 8.94425V7.49707H8V15.0003H8.46875V12.9983L9.46534 13.9326L10.1283 13.3112L8.46875 11.7554V10.1872Z",
    fill: "#FCD0A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4802 2.35059L4.8186 2.97332L7.5312 5.50627V7.49699H8.28073L7.99995 4.70348L5.4802 2.35059Z",
    fill: "#6BC800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5197 2.35059L8 4.70348V7.49699H8.46875V5.50627L11.1813 2.97332L10.5197 2.35059Z",
    fill: "#00A400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.05762V7.93652H8L8.46875 7.49707L8 7.05762H0Z",
    fill: "#00A400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.05762H16V7.93652H8V7.05762Z",
    fill: "#006C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiz);
export default __webpack_public_path__ + "static/media/raiz.e2b78c4152def2af6a1333f4c3455b06.svg";
export { ForwardRef as ReactComponent };